import { API_APP_URL, API_URL } from "../../helpers/environment";
import { headersFormDataToken, headersJson, headersJsonToken } from "../requestHeaders";

export function getModuleType(payload = { page: 1, rowsPerPage: 1000 }) {
  return fetch(`${API_URL}/module-type/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => data.body.data);
}

export async function uploadFile(payload) {
  return await fetch(`${API_URL}/file/upload-file`, {
    method: "POST",
    headers: headersFormDataToken(),
    body: payload,
  })
    .then((res) => res.json())
    .then((data) => data.body.message);
}

export function findPaymentQR(code) {
  return fetch(`${API_APP_URL}/payment/find-qr-payment/${code}`, {
    method: "POST",
    headers: headersJson(),
  })
    .then((res) => res.json())
    .then((data) => data.body || {});
}
